import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import {
    withStyles,
    TextField,

} from '@material-ui/core';

const styles = theme => ({
    textField: {
        margin: `0 ${theme.spacing(2)}px`,

        [theme.breakpoints.down('xs')]: {
            margin: theme.spacing(0, 1, 2, 0),
        },
    },
});

class MultiTextInput extends React.Component {
    // handleChange = name => (event) => {
    //     this.setState({
    //         [name]: event.target.value,
    //     }, () => {
    //         if (this.updateTimeout) {
    //             clearTimeout(this.updateTimeout);
    //         }
    //         this.updateTimeout = setTimeout(this.update, 200);
    //     });
    // }

    // update = () => {
    //     const data = Object.keys(defaultState).reduce(
    //         (obj, key) => (hasValue(this.state[key]) ? { ...obj, [key]: trimIfString(this.state[key]) } : { ...obj }), {},
    //     );

    //     if (data.questions) {
    //         data.questions = data.questions.map(q => ({
    //             ...q, question: trimIfString(q.question),
    //         }));
    //     }

    //     this.props.onUpdate(data);
    // }

    handleChange = name => (event) => {
        this.props.onChange({
            target: {
                value: {
                    ...this.props.values,
                    [name]: event.target.value,
                },
            },
        });
    }

    render() {
        const {
            classes, translate, fieldDefs, values,
        } = this.props;

        // const getError = (name) => {
        //     const error = validationErrors && validationErrors[name];
        //     return error ? translate(error) : null;
        // };

        return (
            <>
                {fieldDefs.map(({
                    name, label, type, ...props
                }) => (
                    <TextField
                        key={name}
                        type={type || 'text'}
                        className={classes.textField}
                        label={label && translate(label)}
                        value={values[name] || ''}
                        onChange={this.handleChange(name)}
                        // error={!!getError(name)}
                        // helperText={getError(name)}
                        InputLabelProps={{ shrink: true }}
                        {...props}
                    />
                ))}
            </>
        );
    }
}

MultiTextInput.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    fieldDefs: PropTypes.arrayOf(PropTypes.object).isRequired,
    values: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    // validationErrors: PropTypes.object,
};

MultiTextInput.defaultProps = {
    onChange: null,
    // validationErrors: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(MultiTextInput));
